import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
  IPublicTransportStationDTO,
  ISupplierRouteStationPreferenceDTO,
  ISupplierRouteTravelPreferenceDTO,
  ISupplierTravelPreferenceDTO,
} from '../interfaces/supplier-travel-preference';
import { BaseDataService } from './base.data.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { IRouteRecommendationUserPreferenceChangeLimitDetails } from '../interfaces/route-recommendations/route-recommendation-user-preference-change-limit-detail';
@Injectable({ providedIn: 'root' })
export class SupplierTravelPreferencesService extends BaseDataService {
  url = '/api/supplier-travel-preferences';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  putSupplierTravelPreferences(dto: {
    supplierRouteTravelPreference: ISupplierRouteTravelPreferenceDTO;
    supplierRouteStationPreferences: ISupplierRouteStationPreferenceDTO[] | null;
  }) {
    return this.handleRequest(
      this.http.put(this.url, dto),
      this.handlersFactory.getForUpdate('Travel Preferences'),
      'Thank you for editing your preferences, these changes will be reflected in your suggested routes in the next 30 minutes. If you already have grabbed route/s this will not be affected.\n',
    );
  }

  getAlgoTravelPreferences(): Promise<ISupplierTravelPreferenceDTO> {
    return this.http.get<ISupplierTravelPreferenceDTO>(this.url).toPromise();
  }

  getAlgoTravelStations(params: { search?: string }): Promise<IPublicTransportStationDTO[]> {
    const httpParams = this.constructHttpParams({ search: params?.search ?? '' });
    return this.http
      .get<IPublicTransportStationDTO[]>(`${this.url}/stations/all`, {
        params: httpParams as HttpParams,
      })
      .toPromise();
  }

  getUserPreferenceChangeLimitDetails(): Promise<IRouteRecommendationUserPreferenceChangeLimitDetails> {
    return this.http
      .get<IRouteRecommendationUserPreferenceChangeLimitDetails>(
        `${this.url}/getUserPreferenceChangeLimitDetails`,
      )
      .toPromise();
  }

  isSupplierPreferencesUpdating(): Promise<boolean> {
    return this.http.get<boolean>(`${this.url}/isSupplierPreferencesUpdating`).toPromise();
  }

  isTravelPreferencesEnabled(): Promise<boolean> {
    return this.http.get<boolean>(`${this.url}/enabled`).toPromise();
  }
}
